import { Component, OnInit } from '@angular/core';
import { FormBuilder,FormControl,FormGroup,Validators,} from "@angular/forms";
//import { LoginService } from "../ApplicationServices/LoginService";
import { LoginService } from "../../ApplicationServices/LoginService";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  registerForm: FormGroup;
  alertmsg: string;
  showAlert: boolean;

  constructor
  (
    private formBuilder: FormBuilder, private loginService: LoginService,

  ) { }

  ngOnInit() {

    this.registerForm = this.formBuilder.group({
         
      emails: new FormControl(),      
     
    });


    

  }

  
  onRegister() {
    

    if( 

    
      this.registerForm.value.emails=='' ||
      this.registerForm.value.firstnames==null 

      ){

      this.alertmsg = "Access denied , e-mail must be filled up !";
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 3000);
     // return;

    }
    
    else
    {


      const formData = new FormData();
      var obj = {
       
       
        UserEmail: this.registerForm.value.emails,
       
      };

      this.alertmsg = "Message is sending , Please wait ......";
      this.showAlert = true;    

      formData.append("params", JSON.stringify(obj));
      this.loginService.sendjoinsubmit(obj).subscribe((event: any) => {
        if (event && event.length > 0) {
          console.log(event);

          //this.alertmsg = event[0].OperationStatus;
          this.alertmsg = "Message is send successfully !";
          this.showAlert = true;
          setTimeout(() => {
            this.showAlert = false;
          }, 3000);

          this.registerForm.reset();


        }
      });


    }


  }

}
